import { Navigate, Route, Routes } from 'react-router-dom'
import Layout from '@/components/Layout'
import Login from '@/pages/Login'
import Callback from '@/pages/Callback'
import Dashboard from '@/pages/Dashboard'
import Trends from '@/pages/Trends'
import Calendar from '@/pages/Calendar'
import DayOfWeek from '@/pages/DayOfWeek'
import Workouts from '@/pages/Workouts'
import Export from '@/pages/Export'
import Debug from '@/pages/Debug'
import { loadTokens } from '@/auth/tokens'

function RequireAuth({ children }: { children: React.ReactNode }) {
  const tokens = loadTokens()
  if (!tokens) return <Navigate to="/login" replace />
  return <>{children}</>
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/callback" element={<Callback />} />
      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="/trends" element={<Trends />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/dayofweek" element={<DayOfWeek />} />
        <Route path="/workouts" element={<Workouts />} />
        <Route path="/export" element={<Export />} />
        <Route path="/debug" element={<Debug />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
